"use client";

import { useAssignPersistQuickAddOnSearchTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/TileEffects/useAssignPersistQuickAddOnSearchTile";
import React from "react";

export const SearchTileEffects = () => {
  useAssignPersistQuickAddOnSearchTile();
  return <></>;
};
